import '../../App.scss'
import React, { Component } from 'react'
import { Switch, Route } from 'react-router-dom'
import { withRouter } from "react-router-dom";
import ViewArticle from './ViewArticle'
import MuseumList from './MuseumList';


class Museum extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {

        return (
            <div className="Museum">
                <Switch>
                    <Route exact path='/museum' component={MuseumList} />
                    <Route path='/museum/post/:blogid/:postid/:title' component={ViewArticle} />
                </Switch>
                <div className="MuseumFooter">
                    <h1></h1>
                        <h2>Found something interesting? We want to hear from you!</h2>
                    <div id="widebutton"className="Register">
                        <p>Submit Exhibit for Display</p>
                    </div>
                </div>
            </div>
        );
    }
}
export default withRouter(Museum) 
